import $ from 'jquery';

if($("body.member#list").length){
	if($(".alert").length){
		alert($(".alert").text());
	}

	const memberId = document.querySelector("body").dataset.memberId;
	document.querySelectorAll(".sessionList a").forEach((el) =>{
		let sessionId = el.href.split("/");
		sessionId = sessionId[sessionId.length - 1];
		const storageKey = `session_data_${sessionId}_${memberId}`;
		const savedData = localStorage.getItem(storageKey);
		if(savedData){
			const nowEl = el.querySelector(".now");
			if(nowEl){
				nowEl.style.display = "grid";
			}
		}
	});
}